module.exports = __webpack_public_path__ + "static/media/permissions.880b905e.svg";